export const getUserProfileUrl = (login: string) =>
  `https://github.com/${login}`;
